
import * as DataUtil from 'Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil';
import ctypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";


export const checkMBox = ({ last, obj }) => {
    if (obj.lastsearchdata[`${ctypes.MBOX}Items`]) {
        let tmp = obj.lastsearchdata[`${ctypes.MBOX}Items`];
        last[`${ctypes.MBOX}`] = tmp.map(item => item.ID).join(";");
        last[`${ctypes.MBOX}_ids`] = last[`${ctypes.MBOX}`];
        last[`${ctypes.MBOX}Items`] = tmp;
    }
    return last;
}

export const setUpFlexSearch = (obj) => {
    let last = {};
    if (DataUtil.isPorscheArchiv()) {
        if (obj && obj.formConfig && obj.formConfig.length) {
            obj.formConfig.forEach(item => {
                if (item.data && item.data.length) {
                    item.data.forEach(el => {
                        if (obj.lastsearchdata) {
                            if (obj.lastsearchdata[el.name]) {
                                if (!last) last = {};
                                last[el.name] = obj.lastsearchdata[el.name];
                                if (obj.lastsearchdata[`${el.name}_tmp`]) {
                                    last[`${el.name}_tmp`] = obj.lastsearchdata[`${el.name}_tmp`];
                                }
                                if (obj.lastsearchdata[`${el.name}Items`]) {
                                    last[`${el.name}Items`] = obj.lastsearchdata[`${el.name}Items`];
                                    last = checkMBox({ last, obj });
                                }
                            } else if (obj.lastsearchdata[`${el.name}Items`]
                                && obj.lastsearchdata[`${el.name}Items`].length) {
                                last[`${el.name}Items`] = obj.lastsearchdata[`${el.name}Items`];
                                last = checkMBox({ last, obj });

                            } else if (obj.lastsearchdata.stock_ids) {
                                last.stock = obj.lastsearchdata.stock ? obj.lastsearchdata.stock : obj.lastsearchdata.stock_ids;
                                last.stock_ids = obj.lastsearchdata.stock_ids;
                            }
                        }
                    })
                }
            })
        }
        //console.log("LOGS: FlexSearchHelper last", last);
        return last;
    }
}

export const updateFlexSearchObj = ({ prevProps, props, state }) => {
    if (DataUtil.isPorscheArchiv() && props.formDesign === ctypes.SEARCH_FORM) {
        if (prevProps.formConfig != props.formConfig) {
            const { lastsearchdata } = props.user.granting.udo;
            let searchedObjects = setUpFlexSearch({
                searchedObjects, lastsearchdata,
                formConfig: props.formConfig
            });
            if (searchedObjects) {
                if (!state[ctypes.MBOX]) {
                    delete searchedObjects[ctypes.MBOX];
                    delete searchedObjects[`${ctypes.MBOX}Items`];
                    delete searchedObjects[`${ctypes.MBOX}_tmp`];
                }
                props.expertSearchSaveData(searchedObjects);
                let obj_tmp = DataUtil.filterObjects(searchedObjects, "_tmp");
                let obj_items = DataUtil.filterObjects(searchedObjects, "Items");
                let obj_checked = DataUtil.filterObjects(searchedObjects, "_checked");
                return { ...obj_tmp, ...obj_items, ...obj_checked, customDataObjects: { ...searchedObjects } };
            }

        }
    }
    return null;
}

export const isFlexSearchMBoxDD = ({ ddname, isSearch }) => {
    if ((DataUtil.isPorscheArchiv() || DataUtil.isDZA() )&& ddname && ddname === ctypes.MBOX && isSearch) {
        return true;
    }
    return false;
}
